import React from "react";
import { AppInitialState, AppNewState } from "./";

export const AppContext = React.createContext({
  appState: AppInitialState,
  setAppState: (appState: AppNewState) => {},
});
